export class Validators {

    static numeric(control) {
        const valid = control.value && !isNaN(control.value);
        return (valid) ? null : { "required": true };
    }

}


/** WEBPACK FOOTER **
 ** ./app/common/Validators.ts
 **/